// src/components/SearchPanel.js
import React from "react";

function SearchPanel({
  searchQuery,
  setSearchQuery,
  categories,
  selectedCategory,
  setSelectedCategory,
  authors,
  selectedAuthor,
  setSelectedAuthor,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) {
  const filtersActive =
	  searchQuery ||
	  selectedCategory !== "all" ||
	  selectedAuthor !== "all" ||
	  startDate ||
	  endDate;

  const handleClearFilters = () => {
	  setSearchQuery("");
	  setSelectedCategory("all");
	  setSelectedAuthor("all");
	  setStartDate("");
	  setEndDate("");
	};

  return (
    <aside className="search-panel">
      <h3>Search Articles</h3>
	  {filtersActive && (
		  <div className="filters-active-indicator">
			Filters active
		  </div>
		)}


      <input
        type="text"
        placeholder="Search..."
        value={searchQuery}
        onChange={e => setSearchQuery(e.target.value)}
      />

      <select
        value={selectedCategory}
        onChange={e => setSelectedCategory(e.target.value)}
      >
        <option value="all">All Categories</option>
        {categories.map(cat => (
          <option key={cat} value={cat}>{cat}</option>
        ))}
      </select>

      <select
        value={selectedAuthor}
        onChange={e => setSelectedAuthor(e.target.value)}
      >
        <option value="all">All Authors</option>
        {authors.map(author => (
          <option key={author} value={author}>{author}</option>
        ))}
      </select>

      <label>
        From
        <input
          type="date"
          value={startDate}
          onChange={e => setStartDate(e.target.value)}
        />
      </label>

      <label>
        To
        <input
          type="date"
          value={endDate}
          onChange={e => setEndDate(e.target.value)}
        />
      </label>
	  <button
		  type="button"
		  className="clear-filters-btn"
		  onClick={handleClearFilters}
		  disabled={!filtersActive}
		>
		  Clear All Filters
		</button>

    </aside>
  );
}

export default SearchPanel;
